import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Label} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import FormModal from './FormModal';

class CommonHeader extends Component {
  render() {
    const {filteredRows, title, name, detail, saveChanges, contentType, code} = this.props;

    return (
      <Card raised fluid>
        <div className="title-bar">
          <div className="title">
            <h2>{title}</h2>
            <Label className="total" color="red">
              {`Total ${name}`}
              <Label.Detail>{filteredRows?.length}</Label.Detail>
            </Label>
            <div className="title-bar-actions">
              <Button
                secondary
                onClick={this.props.navigateBack}
              >
                Cerrar
              </Button>
              <FormModal
                detail={detail}
                saveChanges={saveChanges}
                headerTitle={title}
                create={true}
                contentType={contentType}
                code={code}
              />
            </div>
          </div>
        </div>
      </Card>
    );
  }
}
 
const mapStateToProps = (state) => {
  const statusSelect = state.processedWarranty.warrantyStatus.map((item) => ({
    'key': item.status,
    'text': item.description.toUpperCase(),
    'value': item.status,
  }));
  statusSelect.unshift({'key': 'TODOS', 'text': 'TODOS', 'value': 'TODOS'});

  return {
    'permissions': state.session.permissions,
    'dealer': state.session.dealerId,
    'processedWarrantyList': state.processedWarranty.processedWarrantyList,
    'warrantySequences': state.processedWarranty.warrantySequences,
    'warrantyStatus': statusSelect,
    'loading': state.processedWarranty.loading,
    'fileData': state.processedWarranty.fileData,
    'code': state.clientManagementForm.code,
  };
};

const {
  withRouter,
  fetchTwcList,
  clearTwcList,
  fetchFileData,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  navigateTo,
  navigateBack,
} = Actions;

const mapDispatchToProps = {
  fetchTwcList,
  fetchFileData,
  clearTwcList,
  fetchWarrantySequences,
  fetchWarrantyStatus,
  addWarrantyChecked,
  removeWarrantyChecked,
  navigateTo,
  navigateBack,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CommonHeader)
);
